import React from "react";
import { Container, Row, Col } from "shards-react";
import MUIDataTable from "mui-datatables";
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import Button from '@material-ui/core/Button';

import api from '../common/api'

  //import { Store } from "../../flux";
  
class SubContactAudit extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        param:'',
        sub_contact_id: '',
        sub_contact_name: '',
        isLoaded: false,
      }
    }

    async componentDidMount() {
      const param = this.getParams()
      var sub_contact_id = param.sub_contact_id
      var contact_id = param.contact_id
      await this.getAudit(sub_contact_id);
      await this.getSubcontact(sub_contact_id);
      this.setState({sub_contact_id: sub_contact_id, 'contact_id': contact_id});

    }
   
   getParams(location) {
      return this.props.match.params
   } 

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '0px 8px 0px 8px',
           fontSize: '0.8rem'
         }
        },
        MuiSvgIcon:{
          root: {
            fontSize: "1.39rem"
          }
        },
        MuiFab:{
          sizeSmall:{
            height: "35px",
            width: "35px"
          }
        }
      }
    });     

   getAudit = (sub_contact_id) => {
     const token = localStorage.getItem('userToken')

     return axios
              .get(api.subcontacts().audit(sub_contact_id),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                let audit = []
                if (res.data.address !== undefined){
                  res.data.address.map((val, idx)=>{
                    audit.push(val.audit[0])
                  })
                }
                if (res.data.subcontact !== undefined){
                  res.data.subcontact.map((val, idx)=>{
                    audit.push(val)
                  })
                }
                if (res.data.audits !== undefined){
                  res.data.audits.map((val, idx)=>{
                    audit.push(val)
                  })
                }

                this.setState({isLoaded: true, data: audit})
              })
              .catch(err =>{console.log(err)
              })

    }

  getSubcontact(sub_contact_id){
   const token =localStorage.getItem('userToken')

    return axios
         .get(api.subcontacts().get(sub_contact_id),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              this.setState({sub_contact_name: res.data[0].firstname + ' ' + res.data[0].lastname})
          })
          .catch(err =>{console.log(err)
          })
  }



  render(){
     const columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: false,
       sort: true,
       sortDirection: 'asc' 
      }
     },
     {
      name: "event",
      label: "Evento",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "user_id",
      label: "Usuario",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "old_values",
      label: "valores anteriores",
      options: {
       filter: false,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
            return (  
                <div>{JSON.stringify(value)}</div>
              );
          }
      }
     },
     {
      name: "new_values",
      label: "Nuevos valores",
      options: {
       filter: false,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
            return (  
                <div>{JSON.stringify(value)}</div>
              );
          }
      }
     },
     {
      name: "created_at",
      label: "Fecha",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     }
    ];

  const options = {
    download: true,
    print:false,
    responsive: 'stacked',
    selectableRowsOnClick: true,
    rowsPerPage: 10,
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
            downloadCsv: "Exportar a CSV"        
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   return(
      <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title={`Auditoría ${this.state.sub_contact_name}`}
                  data={Object.values(this.state.data)}
                  columns={columns}
                  options={options}
                 />

                <div style={{textAlign: "right"}}>
                   <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/subcontacts/"+this.state.contact_id}>
                      Volver
                  </Button>
                </div>
              </MuiThemeProvider>
            </Col>
          </Row>
         </Container>

    );
  }


}

export default SubContactAudit;   